import { add, get } from '../../cart/ajax_cart';

export default function (event) {
  const cartB =
    document.querySelector('cart-notification') ||
    document.querySelector('cart-drawer');

  $('body').on('click', '.variant-selector form button', function (e) {
    e.preventDefault();
    const $this = $(this);
    const variantId = $this.data('variant-id');
    const sections = cartB
      .getSectionsToRender()
      .map((section) => section.id)
      .toString();
    add(variantId, 1, sections, (response) => {
      setTimeout(() => {
        cartB.renderContents(JSON.parse(response));
      });

      if (cartB && cartB.classList.contains('is-empty'))
        cartB.classList.remove('is-empty');

      // open mini cart
      const elem = document.getElementById('cart-icon-bubble');
      elem.dispatchEvent(new Event('click')); // Fire event
      get((res) => {
        // update count pill
        const { item_count } = JSON.parse(res);
        $(
          'header.mrHeader .header__icon .cart-count-bubble span[aria-hidden="true"]',
        ).html(item_count);
        const cart = JSON.parse(res);

        $('.header__icon--cart').trigger('click');
        // update cart object with variants
        fetch('/cart.js')
          .then((res) => res.json())
          .then((data) => {
            data.items.map((item) => {
              const cartItemIndex = cart.items.findIndex(
                (i) => i.id === item.variant_id,
              );
              cart.items[cartItemIndex].variant = item.variant;
            });
          })
          .catch((err) => {
            // console.log(err, 'testing');
          });
      });
    });
  });
}
